import ss from './Session';
import axios from './Axios'

const randomString = (length: number) =>
  new Array(length).fill(0)
    .map((x) => String.fromCharCode(65 + Math.floor(Math.random() * 2) * 32 + Math.floor(Math.random() * 26)))
    .join("");

// eslint-disable-next-line no-template-curly-in-string
const package_version:string = (((window as any)?.package_version || "NA") === '${package_version}')?"DEV":((window as any)?.package_version || "NA");
const platform = "web";
    
export async function logBehavior (what: string, detail?: any) {
    if (!detail){
        detail = {}
    }

    if (!detail.page){
        detail.page = window.location.pathname;
    }

    if (!sessionStorage.getItem('sessionid')){
        let currentTime = Date.now()/1000;
        let sessionid = localStorage.getItem('sessionid');
        let sessionNumber = 1;
        try {
            sessionNumber = Number(localStorage.getItem('session:number') || "0") || 0;
            sessionNumber += 1;
        }catch(e){
            console.error('invalid sessionNumber', e);
        }
        if (!sessionid){
            sessionid = randomString(16);
            localStorage.setItem('sessionid', sessionid);
            localStorage.setItem('session:firstStartedAt', String(currentTime));

            await sendBehavior("sessionStart", {});
        }else {
            sessionNumber += 1;
            await sendBehavior("revisit", {
                interval: currentTime - Number(localStorage.getItem('session:lastStartedAt') || '0'),
                intervalFromStart: currentTime - Number(localStorage.getItem('session:firstStartedAt') || '0'),
                sessionNumber
            });
        }
        localStorage.setItem('session:lastStartedAt', String(currentTime));
        localStorage.setItem('session:number', String(sessionNumber));
        sessionStorage.setItem('sessionid', sessionid);
    }

    return await sendBehavior(what, detail);
}

async function sendBehavior (what: string, detail: any) {
    let sessionid = localStorage.getItem('sessionid');
    if (!detail.page){
        if ('canonicalPath' in window){
            detail.page = (window as any).canonicalPath;
        }else{
            detail.page = window.location.pathname;
        }
    }
    
    if (['127.0.0.1', 'localhost:3000', 'koreanmate.app:3000', 'localhost:3001', 'koreanmate.app:3001',
        'dev.koreanmate.app', 'stage.koreanmate.app'
    ].includes(window.location.host)){
        detail.debug = true;
    }
    
    let userid = ss.getCurrentSession().userid;
    try{
        let res = await axios.post('/behavior', {logs:[ {what, userid, sessionid, detail, package_version, platform} ]}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        // Add your analytics tracking service here if needed
        // Example: await analytics.logEvent(what, {userid, sessionid, detail});

        if (res.data && res.data.code === 200){
            return true;
        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}

export async function logBulkBehavior (arr: {sessionid: string, userid: string, what: string, detail: any}[]) {
    let userid = ss.getCurrentSession().userid;
    let sessionid = localStorage.getItem('sessionid');

    let logs = arr.map(row => ({
        sessionid,
        userid,
        what: row.what,
        package_version,
        platform,
        detail: {
            page: (window as any).canonicalPath || window.location.pathname,
            ...(row.detail),
            ...((['127.0.0.1', 'localhost:3000', 'koreanmate.app:3000', 'localhost:3001', 'koreanmate.app:3001',
                    'dev.koreanmate.app', 'stage.koreanmate.app'
                    ].includes(window.location.host))
                ?{debug: true}:{})
        },
    }))
    try{
        let res = await axios.post('/behavior', {logs}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            return true;
        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}